import React from 'react';
import { Navigate } from 'react-router-dom';


import useGlobalState from 'Hooks/useGlobalState';

const AdminMain = () => {
	const [globalState, ] = useGlobalState();
	const { user } = globalState;
	let url = '/admin/organisation/' + user.org.uuid;

	return (
		<Navigate to={url} replace={true} />
	);
};

export default AdminMain;